import { createContext } from "react";

const FeatureFlagContext = createContext({ featureEnabled: false });

export default FeatureFlagContext;
